import { Tag, Tooltip } from "antd";
import {
  CODE_STATUS,
  CODE_STATUS_COLOR,
  CODE_STATUS_LABEL,
  isSwitchedOffByShoup,
} from "../commons/discountCodes.helpers";
import { CODES_COPY } from "../commons/discountCodes.copy";

/**
 * Status tag for a code. CANCELLED shows the Ended tag with a tooltip on a
 * focusable host (same pattern as LinkOnlyBadge); a code ShoUp switched off
 * (`endedReason` CANCELLED_BY_OPS) reads "Switched off by ShoUp" (D76).
 */
function CodeStatusTag({ status, endedReason }) {
  const switchedOff = isSwitchedOffByShoup({
    status,
    ended_reason: endedReason,
  });
  const tag = (
    <Tag color={CODE_STATUS_COLOR[status] ?? "default"}>
      {switchedOff
        ? CODES_COPY.switchedOffTag
        : (CODE_STATUS_LABEL[status] ?? status)}
    </Tag>
  );
  if (status !== CODE_STATUS.CANCELLED) return tag;
  return (
    <Tooltip
      title={
        switchedOff ? CODES_COPY.switchedOffDetail : CODES_COPY.cancelledTooltip
      }
    >
      <span tabIndex={0} className="inline-flex">
        {tag}
      </span>
    </Tooltip>
  );
}

export default CodeStatusTag;
